import { useQuery, useApolloClient } from '@apollo/client';
import { getOr } from 'lodash/fp';
import { CURRENT_SERVICE } from '../GraphQL/Queries';

const useService = () => {
  const { data } = useQuery(CURRENT_SERVICE);
  const client = useApolloClient();

  const setService = (service) => {
    client.writeQuery({
      query: CURRENT_SERVICE,
      data: {
        currentService: {
          __typename: 'currentService',
          service,
        },
      },
    });
  };

  return {
    setService,
    currentService: getOr('error', 'currentService.service', data),
  };
};

export default useService;
